import { useQuery } from '@tanstack/react-query';
import { fetchAgentPerQueueBreakdown } from '@/lib/axios/api/widgets.api';

export function useAgentPerQueueBreakdown(agentId: string | null | undefined, startDate: string | undefined, endDate: string | undefined, queueMicrosoftIds?: string[] | null) {
  const query = useQuery({
    queryKey: ['agentPerQueueBreakdown', agentId, startDate, endDate, queueMicrosoftIds] as const,
    queryFn: ({ signal }) => fetchAgentPerQueueBreakdown({ agentId, startTime: startDate, endTime: endDate, queueMicrosoftIds, signal }),
    enabled: !!agentId && !!startDate && !!endDate,
  });

  return {
    queues: query.data?.queues ?? [],
    totalHandled: query.data?.totalHandled ?? 0,
    totalMissed: query.data?.totalMissed ?? 0,
    totalOffered: query.data?.totalOffered ?? 0,
    isLoading: query.isPending && query.fetchStatus !== 'idle',
    isError: query.isError,
  };
}
